<button fastsearchSelect type="button" class="btn btn-light btn-block btn-sm text-left" (click)="goToDetail(data.id)">
    <div class="row">
      <div class="col-3 p-0">
        <img
          alt="{{ data.name }}"
          class="img-fluid"
          *ngIf="data.extra.images && data.extra.images[0]; else noimage"
          src="https://cdn1.gung.io/fit-in/100x100/filters:fill(white):background_color(white):etag({{
            data.extra.images[0].s3ETag
          }}):format(jpeg)/{{ data.extra.images[0].s3Uri }}"
        />
        <ng-template #noimage>
          <img
            class="card-img-top img-fluid w-100"
            src="https://cdn1.gung.io/fit-in/100x100/filters:fill(white):background_color(white)/images/no-image.jpg"
            alt="NO IMAGE"
            class="img-fluid mx-auto d-block"
          />
        </ng-template>
      </div>
      <div class="col-9 text-truncate">
        <span class="d-block">
          <small
            ><b>{{ data.id }}</b></small
          > <small *ngIf="finnishCustomerWithD && projectName === 'helo'"> - {{ data?.extra?.ar?.q_ar_sstl }} </small>

          @if (!!data.extra?.price && showB2CPrices) {
            <lib-price class="float-right" [price]="data.extra.price?.extra?.b2cPrice" [currency]="data.extra.price.customerGrossPrice.currencyCode"></lib-price>
          } @else if (!!data.extra?.price) {
            <lib-price class="float-right" [price]="data.extra.price" type="NET"></lib-price>
          }
        </span>
        <br />
        <span>{{ data.name }}</span>
      </div>
    </div>
  </button>

